import React, { useState } from "react";
import "../../Styles/serviceComponenetsStyles/cardslider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function CardSlider() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const cards = [
    {
      id: 1,
      heading: "Static Web Apps",
      text: "These are simple websites that display the same content to everyuser. Theyre often used for informational purposes and dont require frequent updates.",
    },
    {
      id: 2,
      heading: "Dynamic Web Apps",
      text: "These apps generate content based on user interactions or input.They typically connect to databases  to retrieve and store data, making them more interactive. ",
    },
    {
      id: 3,
      heading: "E-commerce Web Apps",
      text: "These apps facilitate online transactions, allowing users to browse, select, and purchase products or services. ",
    },
    {
      id: 4,
      heading: "Social Media Web Apps",
      text: "Platforms like Facebook, Twitter,and LinkedIn fall into this category.They enable users to connect,share content, and interact with each other. ",
    },
    {
      id: 5,
      heading: "Content Management Systems (CMS)",
      text: "These apps allow users to create,manage, and publish digital content on the web. Examples include WordPress, Drupal, and Joomla. ",
    },
    {
      id: 6,
      heading: "Enterprise Web Apps",
      text: "These are custom-built applications designed to meet specific business needs, such as CRM systems, project management tools, and internal communication platforms.",
    },
    {
      id: 7,
      heading: "Real-Time Web Apps",
      text: "These apps deliver content or updates to users instantly, without the need to refresh the page.Examples include chat applications and collaborative editing tools.",
    },
    {
      id: 8,
      heading: "Progressive Web Apps (PWAs)",
      text: "PWAs are web applications that utilize modern web technologies to provide a native app-like experience, including offline capabilities, push notifications, and device hardware access.",
    },
    {
      id: 9,
      heading: "Single Page Applications (SPAs)",
      text: "SPAs load a single HTML page and dynamically update the content as the user interacts with the app. They provide a seamless and fluid user experience",
    },
    {
      id: 10,
      heading: "API-based Web App",
      text: "These apps rely heavily on APIs (Application Programmin Interfaces) to fetch and manipulate data from external sources. They often serve as frontends for various backend services",
    },
  ];

  return (
    <div className="card-slider-container">
      <div className="cardsiliderHeading">
        <div className="cardHead">Explore Our Varied Website Offerings</div>
        <div className="cardheadUnderline"></div>
      </div>
      <Slider {...settings}>
        {cards.map((card) => (
          <div key={card.id} className="card">
            <div className="card-heading">{card.heading}</div>
            <div className="card-text">{card.text}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
